var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-dialog"},[_c('el-dialog',{attrs:{"visible":_vm.visible,"title":_vm.title,"close-on-click-modal":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }